/**
 * Single source of truth for the active privacy policy version and its
 * human-readable display date — shared across web, mobile, and the
 * extension so the version users see on the policy page is the version
 * recorded against their account at register/join time.
 *
 * Both values must be updated together whenever the policy text changes:
 * - `PRIVACY_POLICY_VERSION` is the machine-readable string we store on
 *   `User.acceptedPrivacyPolicyVersion` during register/join and log in
 *   the `CONSENT_ACCEPTED` audit entry.
 * - `PRIVACY_POLICY_DISPLAY_DATE` is what the policy page shows to
 *   the user ("Last updated: …").
 *
 * Previously these two values lived only in packages/web (with the
 * mobile register screen sending no version at all — every mobile
 * signup got rejected with a Zod validation error). Hoisting to
 * @clinikchat/shared closes that gap and prevents the web-vs-mobile
 * drift that already bit us once between the page render and the
 * register POST.
 *
 * When updating: bump both values at the same time, get lawyer sign-off
 * on the new text, then apply.
 */
export const PRIVACY_POLICY_VERSION = 'v0.1.0';
export const PRIVACY_POLICY_DISPLAY_DATE = '24 April 2026';
//# sourceMappingURL=privacy.js.map